<template>
  <div style="height: calc(100vh - 120px);">
    <listToolbar :toolbar="toolbar" @toolTap="toolTap" @addTap="addTap" />
    <listTable
      :list="list"
      :page="page"
      :loading="loading"
      :total="total"
      :pageSize="pageSize"
      :columns="columns"
      @page-change="pageChange" />
    <el-drawer v-model="formDrawerVisible" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible" style="padding-left: 16px; padding-right: 16px;">
        <Form :columns="addColumns" :type="typeForm" @submit="submit" />
      </div>
    </el-drawer>
    <el-drawer v-model="formDrawerVisible2" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible2" style="padding-left: 16px; padding-right: 16px;">
        <formSee :columns="addColumns" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  goodsTypeList, schoolGoodsDetail,
  schoolGoodsList,
  schoolGoodsStatus,
  stockGoodsDel,
  stockGoodsSubmit
} from '@/apis/common'
import ListToolbar from '@/components/system/listToolbar.vue'
import listTable from '@/components/system/listTable.vue'
import Form from '@/components/system/form.vue'
import formSee from '@/components/system/formSee.vue'

export default {
  name: 'inbound',
  components: { formSee, Form, listTable, ListToolbar },
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      page: 1,
      pageSize: 15,
      total: 0,
      loading: false,
      toolbar: [
        {type: 'input', label: '商品名称', model: 'goods_name', value: ''},
        {type: 'select', label: '商品类型', model: 'type_id', value: '', options: []},
        {type: 'button', label: '搜索', icon: 'el-icon-search', def: 'default', key: 'search'},
        {type: 'button', label: '添加', def: 'primary',key: 'add'}
      ],
      formData: {
        goods_name: '',
        type_id: ''
      },
      list: [],
      columns: [
        {label: '商品ID', prop: 'id', width: 100, type: 'text'},
        {label: '商品名称', prop: 'goods_name', width: 200, type: 'text'},
        {label: '分类', prop: 'goods_type_id', width: 100, type: 'json', deputy: 'category'},
        {label: '标准进货价', prop: 'buying_price', width: 100, type: 'text'},
        {label: '标准销售价', prop: 'sale_price', width: 100, type: 'text'},
        {label: '利润', prop: 'profit', width: 100, type: 'text'},
        {label: '库存', prop: 'stock', width: 100, type: 'text'},
        {label: '状态', prop: 'status', width: 80, type: 'switch', change: (e,v) => this.changeStatus(e,v)},
        {label: '添加时间', prop: 'created_at', width: 150, type: 'text'},
        {label: '备注', prop: 'note', width: 100, type: 'text'},
        {label: '操作', width: 260, type: 'but', arr: [
            {type: 'default', icon: 'el-icon-document', label: '查看', onClick: (row) => this.seeDetails(row)},
            {type: 'primary', icon: 'el-icon-edit', label: '修改', onClick: (row) => this.modify(row)},
            {type: 'danger', icon: 'el-icon-delete', label: '删除', onClick: (row) => this.del(row)}
          ]}
      ],
      formDrawerVisible: false,
      formDrawerVisible2: false,
      addColumns: [
        {label: '分类', prop: 'goods_type_id', type: 'select', value: '',options: []},
        {label: '产品名称', prop: 'goods_name', type: 'input',value: ''},
        {label: '标准进货价', prop: 'buying_price', type: 'input',value: ''},
        {label: '标准销售价', prop: 'sale_price', type: 'input',value: ''},
        {label: '品牌', prop: 'brand', type: 'input',value: ''},
        {label: '颜色', prop: 'color', type: 'input',value: ''},
        {label: '规格', prop: 'specs', type: 'input',value: ''},
        {label: '供应商', prop: 'supplier', type: 'input',value: ''},
        {label: '生产日期', prop: 'produce_date', type: 'date',value: ''},
        {label: '库存下限', prop: 'stock_warn', type: 'input',value: ''},
        {label: '商品图片', prop: 'picurl', type: 'img',value: '', limit: 10},
        {label: '备注信息', prop: 'note', type: 'input',value: ''},
      ],
      typeForm: 'add',
      addFormData: {}
    }
  },
  mounted() {
    this.getSchoolGoodsList()
    this.getGoodsTypeList()
  },
  methods:{
    getSchoolGoodsDetail(row) {
      schoolGoodsDetail({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        goods_id: row.id
      }).then(res => {
        this.addColumns.forEach(item => {
          item.value = res.data.data[item.prop]
        })
      })
    },
    // 查看
    seeDetails(row) {
      this.getSchoolGoodsDetail(row)
      this.formDrawerVisible2 = true
    },
    submit(e,n) {
      let form = {
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        goods_id: n === 'edit' ? this.addFormData.id : '',
        ...e
      }
      stockGoodsSubmit(form).then(res => {
        this.formDrawerVisible = false
        this.$message.success('操作成功')
        this.getSchoolGoodsList()
      })
    },
    // 删除
    del(row) {
      this.addFormData = row
      this.$confirm('确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stockGoodsDel({
          admin_id: this.info.id,
          school_id: this.info.agency_school_id,
          goods_id: row.id
        }).then(res => {
          this.$message.success('删除成功')
          this.getSchoolGoodsList()
        })
      }).catch(() => {})
    },
    changeStatus(e,v) {
      schoolGoodsStatus({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        goods_id: v.id,
        status: e ? 1 : 0
      }).then(res => {
      })
    },
    // 修改
    modify(row) {
      this.addFormData = row
      this.typeForm = 'edit'
      this.getSchoolGoodsDetail(row)
      this.formDrawerVisible = true
    },
    addTap() {
      this.addColumns.forEach(item => {
        item.value = ''
      })
      this.formDrawerVisible = true
      this.typeForm = 'add'
    },
    // 分页
    pageChange(e) {
      this.page = e
      this.getSchoolGoodsList()
    },
    toolTap(data) {
      this.formData = data
      this.page = 1
      this.getSchoolGoodsList()
    },
    getGoodsTypeList() {
      goodsTypeList({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
      }).then(res => {
        this.toolbar[1].options = res.data.data.map(x => {
          return {label: x.name, value: x.id}
        })
        this.addColumns[0].options = res.data.data.map(x => {
          return {label: x.name, value: x.id}
        })
      })
    },
    getSchoolGoodsList() {
      this.loading = true
      schoolGoodsList({
        admin_id: this.info.id,
        school_id: this.info.agency_school_id,
        page: this.page,
        pagesize: this.pageSize,
        ...this.formData
      }).then(res => {
        this.total = res.data.data.count
        this.list = res.data.data.list.map(x => {
          x.status = x.status === 1
          return x
        })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
